/** Gemeinsame Anzeige-Helfer der Plattform-Verwaltung. */

export function dt(v: Date | string | null | undefined): string {
  if (!v) return "—";
  return new Date(v).toLocaleString("de-AT", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** „vor 3 Tagen" — für Anmeldungen/Aktivität, wo es auf die Größenordnung ankommt. */
export function ago(v: Date | string | null | undefined): string {
  if (!v) return "nie";
  const ms = Date.now() - new Date(v).getTime();
  const min = Math.round(ms / 60000);
  if (min < 2) return "gerade eben";
  if (min < 60) return `vor ${min} Min.`;
  const h = Math.round(min / 60);
  if (h < 24) return `vor ${h} Std.`;
  const d = Math.round(h / 24);
  return d === 1 ? "gestern" : `vor ${d} Tagen`;
}

export const nf = (n: number) => n.toLocaleString("de-AT");

export const ROLE_LABEL: Record<string, string> = {
  owner: "Inhaber",
  admin: "Administrator",
  office: "Büro",
  field: "Monteur",
};
